import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import Img from "gatsby-image"
import Helmet from "react-helmet";

import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Content, { HTMLContent } from "../components/Content";
import Layout from "../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "grid",
      gridTemplateRows: "1fr 11fr",
      gridArea: "content",
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4),
      width: "100vw"
    }
  })
);

export const PropertyManagementTemplate = ({
  title,
  content,
  contentComponent,
  image,
  helmet
}): ReactElement => {
  const classes = useStyles();
  const PageContent = contentComponent || Content;

  return (
    <Container className={classes.root} component="main" fixed>
      {helmet || ""}
      <Typography component="h1" variant="h4">
        {title}
      </Typography>
      <Img fluid={image.childImageSharp.fluid}/>
      <PageContent className="content" content={content} />
    </Container>
  );
};

PropertyManagementTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
  helmet: PropTypes.object
};

const PropertyManagement = ({ data, location }): ReactElement => {
  const { markdownRemark: post } = data;
  const rootUrl = "https://williamslynch.co.uk";

  return (
    <Layout pathname={location.pathname}>
      <PropertyManagementTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
        image={post.frontmatter.featuredimage}
        helmet={
          <Helmet titleTemplate="%s">
            <title>{`${post.frontmatter.title}`}</title>
            <meta name="description" content={`${post.frontmatter.description}`} />
            <meta name="image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
            <meta name="og:image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
            <meta name="twitter:image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
          </Helmet>
        }
      />
    </Layout>
  );
};

PropertyManagement.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object
};

export default PropertyManagement;

export const pageQuery = graphql`
  query propertyManagement($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        featuredimage {
          childImageSharp {
            fluid(maxWidth: 640, quality: 64) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
